import { createAsyncThunk } from "@reduxjs/toolkit";
import { ReportExportService } from "../../services/ReportExportService";
import {
  ReportExportResponse,
  ReportExportRequest,
} from "../../models/ReportExport.model";

export const ExportToPdf = createAsyncThunk<
  ReportExportResponse,
  {
    reportData: Omit<
      ReportExportRequest,
      "exportFormat" | "token" | "companyKey"
    >;
    token: string;
    companyKey: string;
  },
  { rejectValue: string }
>(
  "reportPdf/export",
  async ({ reportData, token, companyKey }, { rejectWithValue }) => {
    try {
      const result = await ReportExportService.exportReport(
        reportData,
        "pdf",
        token,
        companyKey,
      );
      if (!result.success) {
        return rejectWithValue(result.message || "Failed to export PDF");
      }
      return result;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error",
      );
    }
  },
);
